<template>
  <div class="container">
    <div class="columns is-mobile">
      <div class="column is-four-fifth">
        <h1 class="title is-size-4-mobile">
          {{ $t("Food list") }} ({{ meals.length }})
        </h1>
      </div>
      <div class="column is-one-fifth">
        <router-link
          v-if="isAdmin"
          class="button is-primary is-outlined is-pulled-right"
          :to="`/projects/${projectId}/meals/create`"
        >
          <span class="icon is-small"><i class="fa fa-plus"></i></span>
          <span>{{ $t("Create") }}</span>
        </router-link>
      </div>
    </div>
    <div class="columns">
      <div class="column is-flex">
        <input-field
          :isFullWidth="true"
          type="search"
          v-model="searchQuery"
          :placeholder="$t('Search meals...')"
        />
        <sort-button
          class="sort-button"
          :sorters="sorters"
          :activeSorter="sorter"
          @change="setSorter"
        />
      </div>
    </div>
    <div class="columns" v-if="categories.length">
      <div class="column"><filter-buttons v-model="filterCategories" /></div>
    </div>
    <div v-if="meals.length == 0">{{ $t("List is empty") }}</div>
    <div v-else class="columns is-multiline is-mobile">
      <div
        v-for="m in meals"
        :key="m.id"
        class="column is-full-mobile is-full-tablet is-half-desktop is-one-third-widescreen"
      >
        <meal-item
          class="meal-item"
          :key="m.id"
          :meal="m"
          :currency="currency"
          :highlight="searchQuery"
          @click.native="toggleActive(m)"
        />
      </div>
    </div>
  </div>
</template>

// TODO add key handlers
<script>
import { state, actions } from "@/store"
import MealItem from "@/components/meal-item"
import SortButton from "@/components/sort-button"
import FilterButtons from "@/components/form/filter-buttons"
import mealService from "@/service/meal-service"
import { InputField } from "@/components/form"

export default {
  name: "meals",
  components: {
    MealItem,
    SortButton,
    FilterButtons,
    InputField
  },
  data() {
    return {
      searchQuery: undefined,
      filterCategories: [],
      sorters: [
        {
          sortBy: "name",
          text: "Name (alphabetical)",
          compareFn: mealService.compareByNameAsc,
          icon: "fa-sort-alpha-asc"
        },
        {
          sortBy: "date",
          text: "Date update (from newest)",
          compareFn: mealService.compareByDateDesc,
          icon: "fa-sort-numeric-desc"
        }
      ]
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler(categories) {
        this.filterCategories = categories.map(category => ({
          value: category,
          selected: false
        }))
      }
    }
  },
  computed: {
    meals() {
      return Object.values(state.project.data.meals)
        .filter(mealService.filterPredicate(this.searchQuery))
        .filter(mealService.filterCategoriesPredicate(this.filterCategories))
        .sort(
          mealService.unionComparator(
            mealService.compareByCategoriesCountDesc(this.filterCategories),
            this.sorter.compareFn
          )
        )
    },
    currency() {
      return state.project.data.currency
    },
    projectId() {
      return state.project.id
    },
    isAdmin() {
      return state.isAdmin
    },
    sorter() {
      const sortBy =
        state.project.members[state.user.email] &&
        state.project.members[state.user.email].mealsSortBy
      return (
        this.sorters.find(sorter => sorter.sortBy === sortBy) || this.sorters[0]
      )
    },
    categories() {
      return state.project.data.availableCategories
    }
  },
  methods: {
    toggleActive(meal) {
      this.$router.push(`/projects/${state.project.id}/meals/${meal.id}`)
    },
    setSorter(sorter) {
      actions.clearErrors()
      actions
        .setMealsSortByToMember(sorter.sortBy)
        .catch(actions.addError("save-meals-sortby-error"))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.meal-item {
  cursor: pointer;
}
label.is-normal {
  padding-top: 0.375em;
  margin-right: 0.5em;
}
.sort-button {
  margin-left: 0.3rem;
}
@include mobile {
  .level {
    .level-item {
      align-items: left;
      justify-content: left;
    }
  }
}
.columns {
  margin-bottom: 0;
}
</style>
